import { render, staticRenderFns } from "./VisualizarAvaliacaoFormacaoDialog.vue?vue&type=template&id=aaf46d46&scoped=true"
import script from "./VisualizarAvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarAvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarAvaliacaoFormacaoDialog.vue?vue&type=style&index=0&id=aaf46d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf46d46",
  null
  
)

export default component.exports